import { ofType } from 'redux-observable';
import { BehaviorSubject } from 'rxjs';
import { mergeMap, withLatestFrom, map } from 'rxjs/operators';

import { validateAddressSuccessForCardMigration } from '@perpay-web/fintech/actions/ui/addressValidation';
import {
    submitCardMigration,
    submitCardMigrationSuccess,
} from '@perpay-web/fintech/actions/ui/cardMigration';
import { getCardAccountUUID } from '@perpay-web/fintech/dataModules/fetchCardAccounts';
import {
    cardMigrationAddressConfirmationModalSetIsModalOpen,
    cardMigrationSetMaterial,
    cardMigrationModalSetStep,
    SUCCESS_STEP,
} from '@perpay-web/fintech/hooks/useCardMigrationContext';
import { PLASTIC_MATERIAL } from '@perpay-web/fintech/utils/cardAccountApplicationMetalUtils';
import { recommendedAddressSameAsOriginal } from '@perpay-web/utils/addressUtils';

const getMaterialStream = (action$) => {
    const subject$ = new BehaviorSubject(PLASTIC_MATERIAL);
    const stream$ = action$.pipe(
        ofType(cardMigrationSetMaterial().type),
        map((action) => action.payload),
    );
    stream$.subscribe(subject$);
    return subject$.asObservable();
};

export const validateAddressForCardMigration = (action$, state$) =>
    action$.pipe(
        ofType(validateAddressSuccessForCardMigration().type),
        withLatestFrom(getMaterialStream(action$), state$),
        mergeMap(([results, material, state]) => {
            const addressValidation = results.payload;

            const {
                addressChangeRecommended,
                originalAddress,
                uspsAddressNotFound,
                validatedAddress,
            } = addressValidation;

            if (
                (addressChangeRecommended &&
                    !recommendedAddressSameAsOriginal(
                        validatedAddress,
                        originalAddress,
                    )) ||
                uspsAddressNotFound
            ) {
                return [
                    cardMigrationAddressConfirmationModalSetIsModalOpen(true),
                ];
            }

            return [
                submitCardMigration({
                    uuid: getCardAccountUUID(state),
                    material,
                    validatedAddress,
                }),
            ];
        }),
    );

export const handleCardMigrationSuccess = (action$) =>
    action$.pipe(
        ofType(submitCardMigrationSuccess().type),
        mergeMap(() => [cardMigrationModalSetStep(SUCCESS_STEP)]),
    );
